import React from 'react';
import Icon from 'components/Icon';
import BaseComponent from 'components/BaseComponent';
import { Modal } from 'antd';
import { Music } from 'components/Material';
import { Img } from 'components/Material';
import { getShowPreviewObj } from '@/routes/Material/Util/components/materialUtil';
import 'components/Modal/modal.less';

/** 在线播放音乐组件 */
export class MusicPlayComponent extends BaseComponent {
    state = {
        musicStatus: '1',       // 0: 暂停 1:播放
        checkObj: this.props.checkObj,
    }

    /** 在显示时，将音乐置为开始 */
    componentWillReceiveProps(nextProps) {
        let { visible, checkObj } = nextProps;
        if (visible) {
            let divObj = this.refs.musicPreview;
            if (divObj) {
                let musicObj = divObj.firstChild;
                if (musicObj.paused) {
                    musicObj.currentTime = 0;
                    musicObj.play();
                }
                this.setState({
                    musicStatus: '1',
                    checkObj,
                });
            } else {
                this.setState({
                    checkObj,
                });
            }
        }
    }

    /** 关闭模态窗的同时,将音乐停止播放 */
    onCloseMusicPreview = (e) => {
        if(e) {
            e.preventDefault;
            e.stopPropagation;
        }
        let divObj = this.refs.musicPreview;
        if (!divObj) {
            return;
        }
        let musicObj = divObj.firstChild;
        if (!musicObj.paused) {
            musicObj.pause();
        }
        this.setState({
            musicStatus: '0',
        });
        this.props.hidePreviewHandler();
    }

    /** 控制音乐频率波动的显隐 */
    onClickMusicAction = () => {
        let musicStatus = '0';
        let divObj = this.refs.musicPreview;
        if (!divObj) {
            return;
        }
        let musicObj = divObj.firstChild;
        if (musicObj.paused) {
            musicStatus = '1';
        }
        this.setState({
            musicStatus,
        });
    }

    /** 
     * 查看下一张或者前一张
     * 0:前一张 1: 下一张
     */
    onNextPreMaterial = (nextPre) => {
        let { previewRows } = this.props;
        let checkObj = this.state.checkObj;
        let showPreviewObj = getShowPreviewObj(nextPre, previewRows, checkObj);
        if (!showPreviewObj || !showPreviewObj.id) {
            return;
        }
        this.setState({
            checkObj: showPreviewObj,
            musicStatus: '1',
        });
    }

    render() {
        const { title, visible, previewRows } = this.props;
        const { musicStatus, checkObj } = this.state;
        if (!checkObj || !checkObj.id) {
            return null;
        }
        let src = checkObj.path || checkObj.sourcepath;
        if (!src) {
            return null;
        }
        let isNextPre = true;
        if (!previewRows || previewRows.length <= 1) {
            isNextPre = false;
        }
        // 渲染音频波动
        let list = [10,20,30,40,30,20,10,5,10,20,40,20,10,20,35,23,13,5,20,30,40,30,20,10,15,10];
        let spanList = list.map((ele, index) => {
            let num = -Math.random();
            return (
                <span key={index} style={{ top: `${20 - ele / 2}px`, height: `${120 + ele}px`, WebkitAnimationDelay: num + "s" }}></span>
            )
        });
        let newTitle = title;
        if (checkObj.name && checkObj.suffix) {
            newTitle = title + " - " + checkObj.name + "." + checkObj.suffix;
        }
        return (
            <Modal
                title={newTitle}
                visible={visible}
                width={930}
                maskClosable={false}
                onCancel={this.onCloseMusicPreview}
                footer={null}
                className="original-preview-model show-modal-head"
            >
                {isNextPre ? (
                    <div className="original-left">
                        <Icon className="left-arrow-o" onClick={(e) => { this.onNextPreMaterial(0) }} />
                    </div>
                ) : null }
                {isNextPre ? (
                    <div className="original-right">
                        <Icon className="right-arrow-o" onClick={(e) => { this.onNextPreMaterial(1) }} />
                    </div>
                ) : null }
                <div className="original-preview">
                    <div className="original-preview-body">
                        <div className="music-vol">{ musicStatus === '1' ? spanList : null }</div>
                        <div className="music-vol-center">
                            <span><Img src="assets/images/material/material-play-music.png"  /></span>
                        </div>
                        <div className="music-vol">{ musicStatus === '1' ? spanList : null }</div>
                    </div>
                </div>
                <div className="music-preview" ref="musicPreview">
                    <Music className="music-preview-comp" controls={"controls"} controlsList="nodownload" autoPlay="autoPlay" src={src} 
                        onClick={() => { 
                            this.onClickMusicAction() 
                        }}
                    />
                </div>
            </Modal>
        )
    }

}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/musicPlayComponent.js